/* src/app/home-new/home-summary-section/home-summary-section.component.scss */
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ffffff;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: var(--ion-color-primary);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b7b7b7;
}
.price-tabs {
  display: flex;
  padding: 4px 6px;
  align-items: center;
  gap: 6px;
  border-radius: 17.659px;
  background: #fff;
  box-shadow: 0 1.261px 5.045px 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 12px;
}
.price-tabs .price-tab {
  border-radius: 18px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: "League Spartan", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  color: #949494;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}
.price-tabs .price-tab.active {
  background: #43c0f6;
  color: #fff;
}
.price-tabs .price-tab.active.cart {
  background: #ff007f;
  color: #fff;
}
.price-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  border: 1px solid #bab8b8;
  border-radius: 16px;
  padding: 12px 16px;
  background: #ffffff;
}
.price-card.price-card--expanded {
  flex-direction: column;
  gap: 6px;
}
.price-card_row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}
.price-card_row .price-card_label--secondary {
  color: #949494;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.price-card_label {
  font-weight: 500;
  font-size: 16px;
}
.price-card_price {
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
}
.price-card_price.price-card_price--secondary {
  font-size: 22px;
  line-height: 26px;
  text-decoration: none;
  color: #949494;
}
.go-cart-button {
  --ion-color-tint: var(--ion-color-primary) !important;
}
.go-cart-button span {
  font-weight: 600;
  font-size: 18px;
}
.go-cart-button ion-icon {
  margin-right: 5px;
  font-size: 22px;
}
hr {
  width: 100%;
  border-top: 1px solid #acacac;
}
.commentBox_label {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}
.commentBox_textarea {
  --padding-top: 16px;
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-bottom: 10px;
  --background: white;
  --border-radius: 10px;
  --border-width: 0;
  font-weight: 400;
  font-size: 16px;
}
.commentBox_textarea textarea {
  overflow: auto;
  border: 1px solid #6f6f6f;
  border-radius: 10px;
  padding: 16px 10px;
  background: white;
}
.groups .groups_title {
  font-size: 22px;
}
.groups .groups_title ion-icon {
  margin-right: 10px;
  z-index: 99;
  cursor: pointer;
}
.groups .groups_title h2 {
  font-weight: 600;
}
.groups .create-group-button {
  margin-bottom: 10px;
}
.groups .create-group-button span {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 1px;
}
.groups .create-group-button ion-icon {
  margin-right: 5px;
  font-size: 14px;
  fill: white;
}
.groups .groups_list {
  height: 560px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  padding-bottom: 160px;
}
.disabled {
  opacity: 40%;
}
.disabled * {
  pointer-events: none;
}
/*# sourceMappingURL=home-summary-section.component-RUA63FQO.css.map */
